import React from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import InputData from "../formulario/input-data/inputData";

interface CancelMovementModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  methods: UseFormReturn<any>;
  isPending: boolean;
}

export function ModalCancelamento({
  open,
  onClose,
  onSubmit,
  methods,
  isPending,
}: CancelMovementModalProps) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = methods;

  return (
    <Modal
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
      open={open}
      onClose={onClose}
    >
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        padding="20px 0"
        display="flex"
        flexDirection="column"
        bgcolor="background.paper" // Use a cor do tema
        color="text.primary"
        p={4}
        borderRadius={2}
        boxShadow={24}
        minWidth={350}
        maxWidth={400}
        mx="auto"
        mt="380px"
        gap={2}
      >
        <Typography variant="h6" component="h2" mb={2}>
          Cancelar Movimentação
        </Typography>

        <InputData
          name="cancellationDate"
          label="Informe a nova data de término estimada"
          methods={methods}
        />

        <TextField
          sx={{ margin: "20px 0 30px" }}
          label="Motivo do Cancelamento"
          multiline
          minRows={3}
          {...register("cancellationReason")}
          error={!!errors.cancellationReason}
          helperText={
            errors.cancellationReason?.message
              ? String(errors.cancellationReason.message)
              : undefined
          }
        />

        <Box display="flex" gap={2} justifyContent="flex-end" mt={2}>
          <Button
            variant="outlined"
            onClick={onClose}
            color="inherit"
            disabled={isPending}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="error"
            disabled={isPending}
          >
            {isPending ? "Cancelando..." : "Confirmar Cancelamento"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
